"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IImage = void 0;
var immutable_1 = require("../../immutable");
var rect_size_1 = require("./rect-size");
exports.IImage = (0, immutable_1.IRecord)({
    src: '',
    rectSize: (0, rect_size_1.IRectSize)()
});
